import React, { useState } from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import "./styles.css";

function Container({ children, userType = "admin" }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="admin-dashboard">
      <Sidebar
        userType={userType}
        mobileMenuOpen={mobileMenuOpen}
        onCloseMobileMenu={closeMobileMenu}
      />
      <div className="main-content">
        <Header onToggleMobileMenu={toggleMobileMenu} mobileMenuOpen={mobileMenuOpen} />
        <div className="page-content">{children}</div>
      </div>
      {/* Overlay para fechar o menu ao clicar fora */}
      {mobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}
    </div>
  );
}

export default Container;
